import { object } from "yup";
import { BasicSettings } from "./types";
import { device } from "./deviceSchema";
import { exchange } from "./exchangeSchema";
import { qos } from "./qosSchema";
import { video } from "./videoSchema";
import { upgrade } from "./upgradeSchema";
import { voIpProt } from "./voIpProtSchema";
import { content } from "./contentSchema";
import { homeScreen } from "./homeScreenSchema";
import { fromSchema } from "collections";

export const deviceSettingsSchema = object<BasicSettings>({
  content,
  device,
  exchange,
  homeScreen,
  qos,
  upgrade,
  video,
  voIpProt
});

export type BasicDeviceSettings = BasicSettings;
/**
 * Normally, just get this from the form, but the form is massive and broken up,
 * we will just export the constant directly.
 */
export const deviceSettingsSchemaFields = fromSchema(deviceSettingsSchema);
